import { useState } from "react";
import "../styles/WhoAmI.scss";
import Fade from "react-reveal/Fade";
import ps from "../assets/ps.png";
import ai from "../assets/ai.png";
import id from "../assets/id.png";
import css from "../assets/css.png";
import html from "../assets/html.png";
import js from "../assets/js.png";
import sass from "../assets/sass.png";
import figma from "../assets/figma.png";
import react from "../assets/react.png";
import rn from "../assets/rn.png";
import wp from "../assets/wp.png";
import vs from "../assets/vs.png";

const WhoAmI = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="boxWho">
      <Fade top>
        <div className="box2">
          <h2 className="titleWho">De mes premiers pixels en 1983 au monde numérique d’aujourd’hui, bienvenue dans mon univers !</h2>

          <p className="textWho">
            Depuis toujours, je suis passionné par l'image, le design et la communication visuelle. Bien avant d'en faire mon métier, je passais déjà une grande partie de mon temps à dessiner, créer et observer ce qui rend une image mémorable. À une époque où les ressources d'apprentissage étaient encore limitées, j'ai commencé en autodidacte, guidé par la curiosité, l'expérimentation et l'envie constante de progresser.
          </p>

          <div className={`textDrawer ${expanded ? "textDrawer--open" : ""}`}>
            <p className="textWho">
              Souhaitant transformer cette passion en véritable expertise, j'ai ensuite suivi plusieurs formations diplômantes, notamment en <strong>Infographie Multimédia (IMM)</strong> puis en <strong>Infographie Metteur en Page (IMEP)</strong>. Ces expériences ont renforcé mes compétences techniques tout en développant ma compréhension du design, de la communication et de l'image de marque.
            </p>
            <p className="textWho">
              Depuis plus de quinze ans, j'évolue dans des univers variés, en agence, en entreprise ou en indépendant. Cette diversité m'a permis de développer une vision globale du métier de graphiste et de directeur artistique, en travaillant aussi bien pour des artisans et des PME que pour des start-ups et de grandes marques internationales.
            </p>
            <p className="textWho">
              L'une des expériences les plus marquantes de mon parcours a été mon poste de <strong>Directeur Artistique chez eYeka</strong>, leader européen du crowdsourcing créatif. J'y ai participé à la création d'identités visuelles, de plateformes digitales, de brand books et de nombreux supports de communication. J'ai également réalisé plus de 800 bannières publicitaires pour des concours impliquant plus de 500 marques internationales. Une expérience enrichissante qui m'a permis d'allier créativité, stratégie de marque et communication digitale.
            </p>
            <p className="textWho">
              Parallèlement, j'exerce une activité de <strong>freelance depuis 2008</strong>. J'ai accompagné de nombreuses entreprises dans leur développement, parfois dès leur création, en intervenant sur leur identité visuelle, leurs packagings, leurs supports de communication, mais aussi sur la conception de produits, de boutiques et de concept stores. Au fil des projets, j'ai appris à voir au-delà du simple aspect graphique pour intégrer les enjeux de positionnement, d'expérience client et de développement de marque.
            </p>
            <p className="textWho">
              J'ai également eu l'opportunité de transmettre mes connaissances en intervenant comme <strong>formateur pour l'INFA</strong>. Cette expérience m'a permis d'accompagner de futurs professionnels du graphisme et du webdesign tout en continuant à enrichir ma propre pratique.
            </p>
            <p className="textWho">
              Curieux de nature et passionné par le digital dans son ensemble, j'ai progressivement élargi mes compétences au développement web. Après m'être formé au <strong>HTML5</strong> et au <strong>CSS3</strong>, j'ai suivi un <strong>bootcamp au Reacteur</strong>, spécialisé en React et React Native. Cette double compétence me permet aujourd'hui de concevoir des interfaces qui allient esthétique, ergonomie et faisabilité technique, tout en anticipant les contraintes liées à l'intégration, au responsive design et à l'expérience utilisateur.
            </p>
            <p className="textWho">
              Au fil des années, j'ai développé une expertise couvrant de nombreux domaines : <strong>direction artistique, branding, identité visuelle, création de logos, brand books, webdesign, UX/UI design, communication digitale, packaging, supports marketing et publicité print ou digitale</strong>.
            </p>
            <p className="textWho">
              Plus qu'un simple métier, le graphisme est pour moi un moyen de raconter des histoires, transmettre des émotions et donner du sens aux projets que j'accompagne. Après plus de quinze ans d'expérience, la passion qui m'animait à mes débuts est toujours la même : imaginer, créer, apprendre, transmettre et relever de nouveaux défis.
            </p>
            <p className="textWho">
              À la croisée du design, de la communication et du développement, je continue chaque jour à mettre cette passion au service de projets ambitieux et de marques qui souhaitent se démarquer.
            </p>
          </div>

          <button className="readMoreBtn" onClick={() => setExpanded(!expanded)}>
            {expanded ? "Lire moins ▲" : "Lire plus ▼"}
          </button>
        </div>
      </Fade>

      <Fade bottom>
        <div className="box1">
          <img src={ps} alt="Photoshop" className="img" title="Photoshop" />
          <img src={ai} alt="Illustrator" className="img" title="Illustrator" />
          <img src={id} alt="InDesign" className="img" title="InDesign" />
          <img src={figma} alt="Figma" className="img" title="Figma" />
          <img src={html} alt="HTML" className="img" title="HTML" />
          <img src={js} alt="JavaScript" className="img" title="JavaScript" />
          <img src={css} alt="CSS" className="img" title="CSS" />
          <img src={sass} alt="SASS" className="img" title="SASS" />
          <img src={react} alt="React" className="img" title="React" />
          <img src={rn} alt="React Native" className="img" title="React Native" />
          <img src={wp} alt="WordPress" className="img" title="WordPress" />
          <img src={vs} alt="Visual Studio" className="img" title="Visual Studio" />
        </div>
      </Fade>
    </div>
  );
};

export default WhoAmI;
